import React from 'react';

import styles from './MainLayout/MainLayout.module.scss';

const Content: React.FC = ({ children }) => {
  return <main className={styles.content}>{children}</main>;
};

export default Content;
